// extracted by mini-css-extract-plugin
export var redoItem = "_or-1";
export var redoTrigger = "_or-0";